module.exports = __webpack_public_path__ + "01_mustache_grey.d687a350.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/01_mustache_grey.png
// module id = vzFV
// module chunks = 0